export interface InternationalAddress {
    line1: string;
    line2: string;
    city: string;
    // replaces state, allows state or province depending on country, Mexico-states, Canada-province
    region: string;
    // replaces zip, U.S. uses zip other countries use postal code, same thing different name
    postalCode: string;
    // default U.S. otherwise allow other options
    country: string;
  }


  export const DEFAULT_COUNTRY = "U.S."

  /** A blank structured address — used as the default for new/legacy (un-migrated) addresses. */
  export function emptyInternationalAddress(): InternationalAddress {
    return { line1: '', line2: '', city: '', region: '', postalCode: '', country: '' };
  }